import { Model } from "pinia-orm";
import Marker from "./Marker";

export default class BasiasBasolSisNearbySiteOther extends Model {
  static entity = "basias_basol_sis_nearby_suite_others";
  static primaryKey = "uuid";
  static aosType = "BASIAS_BASOL_SIS_NEARBY_SITE_OTHER";

  static typeKey = "basiasBasolSisNearbySiteOtherType";

  static types() {
    return {
      BASIAS_BASOL_SIS_NEARBY_SITE_OTHER_FUSION: BasiasBasolSisNearbySiteOtherFusion,
    };
  }

  static fields() {
    return {
      uuid: this.uid(""),
      type: this.attr(null),
      label: this.attr(null),
      reference: this.string(""),
      referenceBasiasBasolSis: this.string(""),
      companyName: this.string(""),
      activityDescription: this.string(""),
      startDateIndication: this.attr(null),
      startDateYear: this.attr(null),
      inOperation: this.boolean(false),
      endDateIndication: this.attr(null),
      endDateYear: this.attr(null),
      siteItself: this.boolean(false),
      address: this.string(""),
      distanceToSite: this.number(0),
      position: this.attr(null),
      assumedHydraulicPositioning: this.attr(null),
      riskOfContaminationTransferToTheSite: this.attr(null),
      riskJustification: this.attr([]),
      remarks: this.string(""),
      tracerCompound: this.attr([]),
      analyticalStandard: this.attr(null),
      quantificationLimit: this.attr(null),
      isSourceTakenIntoAccount: this.boolean(true),
      justification: this.string(null),
      environmentsPotentiallyImpacted: this.attr([]),
      marker: this.morphOne(Marker, "markable_id", "markable_type"),
      typology: this.attr("BASIAS_BASOL_SIS_NEARBY_SITE_OTHER"),
      tagsType: this.attr([]),
      incertitudeDescription: this.attr(null),
      incertitudeCategory: this.attr(null),
    };
  }
}

export class BasiasBasolSisNearbySiteOtherFusion extends BasiasBasolSisNearbySiteOther {
  static entity = "basiasBasolSisNearbySiteOtherFusions";
  static primaryKey = "uuid";
  static baseEntity = "basias_basol_sis_nearby_suite_others";

  static fields() {
    return {
      ...super.fields(),
      basiasBasolSisNearbySiteOthers: this.attr([]),
      basiasBasolSisNearbySiteOtherType: this.string("BASIAS_BASOL_SIS_NEARBY_SITE_OTHER_FUSION"),
    };
  }
}
